// extracted by mini-css-extract-plugin
export default {"product_section":"ProductSection_product_section__Hastu"};